import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  background: black;
  .wrap {
    margin-left: auto;
    margin-right: auto;
    max-width: 1280px;
  }
`

const Proportional = styled.div`
  position: relative;
  height: 0;
  padding-bottom: 56.25%;

  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`
const Embed = ({ iframe }) => {
  return (
    <Container>
      <div className="wrap">
        <Proportional
          dangerouslySetInnerHTML={{ __html: iframe }}></Proportional>
      </div>
    </Container>
  )
}

export default Embed
